import Skeleton from "react-loading-skeleton";
import { useTotpSecret } from "./totpSecret/useTotpSecret";
import { translate } from "@/config/translator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCopy } from "@fortawesome/pro-light-svg-icons";
import { AuthenticatorData } from "./useMfaScanAuthenticatorQr";

type TotpSecretProps = {
  authenticatorData: AuthenticatorData | undefined;
  onCopySecret: () => void;
  showCopyCheckmark: boolean;
};

export function TotpSecret({
  authenticatorData,
  onCopySecret,
  showCopyCheckmark,
}: TotpSecretProps) {
  const { isTablet, lang } = useTotpSecret();
  return (
    <div className="flex flex-col items-start gap-1 w-fit">
      <div className="text-font-secondary">{translate("totpSecret", lang)}</div>

      <div className="flex flex-row gap-3">
        <div className="border border-neutral rounded-sm py-2 px-4 break-all">
          {authenticatorData?.secret ?? (
            <Skeleton width={isTablet ? 285 : 200} />
          )}
        </div>
        <button
          disabled={!authenticatorData || showCopyCheckmark}
          onClick={onCopySecret}
        >
          <FontAwesomeIcon
            icon={showCopyCheckmark ? faCircleCheck : faCopy}
            className={`${
              authenticatorData ? "text-font-secondary" : "text-neutral"
            } text-xl cursor-pointer`}
          />
        </button>
      </div>
    </div>
  );
}
